<template>
  <v-container class="limited">
    <beneficiary-data></beneficiary-data>
    <v-card class="pa-5" :color="highContrast ? 'datk' : 'white'" column>
      <v-layout column>
        <v-layout justify-space-between align-center row>
          <h4
            class="subheading font-weight-bold font-weight-light primary--text mb-3"
          >
            Carta de Portabilidade
          </h4>
        </v-layout>
        <v-layout justify-space-between align-center row>
          <h2 class="subheading font-weight-light mb-3">
            É um comprovante que atesta que o beneficiário cumpriu o tempo
            mínimo para ter acesso á portabilidade.
          </h2>
        </v-layout>
        <v-layout>
          <v-btn
            flat
            @click="downloadFile"
            :color="highContrast ? 'white' : 'primary'"
            outline
            >GERAR CARTA DE PORTABILIDADE</v-btn
          >
        </v-layout>
      </v-layout>
    </v-card>
    <modal-carta-portabilidade
      @close="downloadCartaPortabilidade"
      @save="downloadCartaPortabilidadeFamilia"
      :titulo="modal.CARTA_PORTABILIDADE.titulo"
      :show="modal.CARTA_PORTABILIDADE.visible"
      :message="modal.CARTA_PORTABILIDADE.content"
    ></modal-carta-portabilidade>
    <loading-dialog
      :show="isLoading"
      :message="loadingMessage"
    ></loading-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";

import BeneficiaryData from "@/components/BeneficiaryData";
import ModalCartaPortabilidade from "@/components/ModalCartaPortabilidade";
import { getCartaPortabilidade } from "@/services/beneficiario";
import LoadingDialog from "@/components/LoadingDialog";
import { download } from "@/utils/download";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

const portal = createNamespacedHelpers("portal");

export default {
  name: "portabilityLetter",
  components: {
    BeneficiaryData,
    LoadingDialog,
    ModalCartaPortabilidade
  },
  computed: {
    ...mapState(["dadosBeneficiario"]),
    ...portal.mapState(["highContrast"]),
    contratoId() {
      return this.dadosBeneficiario.contratoId;
    },
    planoRegistroAns() {
      return this.dadosBeneficiario.planoRegistroAns;
    }
  },
  data() {
    return {
      loadingMessage: null,
      modal: {
        CARTA_PORTABILIDADE: {
          visible: false,
          content: "Deseja gerar carta de portabilidade para dependentes?",
          titulo: "Solicitação carta de portabilidade"
        }
      },
      headers: [
        { text: "Documento", value: "titulo", sortable: false },
        { text: "Ação", value: "ação", sortable: false }
      ],
      dialog: false,
      isLoading: false,
      geraFamilia: false,
      items: [{ titulo: "Carta de portabilidade" }]
    };
  },
  async created() {},
  methods: {
    ...mapMutations(["setErrorToast"]),
    downloadCartaPortabilidade() {
      this.close();
      this.isLoading = true;

      let filename = "";
      getCartaPortabilidade(false, this.dadosBeneficiario.id)
        .then(response => {
          filename = response.headers["content-disposition"].replace(
            "attachment; filename=",
            ""
          );
          download(response.data, filename.replace(/"/g, ""));
        })
        .finally(() => (this.isLoading = false));
    },
    downloadCartaPortabilidadeFamilia() {
      this.close();
      this.isLoading = true;

      let filename = "";
      getCartaPortabilidade(true, this.dadosBeneficiario.titularId)
        .then(response => {
          filename = response.headers["content-disposition"].replace(
            "attachment; filename=",
            ""
          );
          download(response.data, filename.replace(/"/g, ""));
        })
        .finally(() => (this.isLoading = false));
    },
    close() {
      this.modal.CARTA_PORTABILIDADE.visible = false;
    },
    downloadFile() {
      if (this.dadosBeneficiario.titular) {
        this.modal.CARTA_PORTABILIDADE.visible = true;
      } else {
        this.downloadCartaPortabilidade();
      }
    }
  }
};
</script>

<style></style>
